import { useEffect } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import usePrevious from 'react-utils/hooks/usePrevious';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
const initialState = {
  pageName: null,
  previousPageName: null,
  currentLink: null,
  backLink: null,
  initialStateSet: false
};
export const useRouteState = create(persist(() => initialState, {
  name: 'academy:routerState',
  storage: createJSONStorage(() => sessionStorage)
}));
export const resetUseRouteState = () => useRouteState.setState(initialState);
export const useNamedRoute = ({
  name,
  path
}) => {
  const location = useLocation();
  const stableRouteState = useRouteState();
  const {
    pageName,
    initialStateSet
  } = stableRouteState;
  const previousSearch = usePrevious(location.search);
  const routeMatch = useRouteMatch({
    path: path,
    exact: true
  });
  useEffect(() => {
    if (routeMatch && pageName !== name || pageName === name && previousSearch !== undefined && location.search !== previousSearch) {
      useRouteState.setState({
        pageName: name,
        currentLink: location.pathname + location.search
      });
    }
  }, [initialStateSet, location.pathname, location.search, name, pageName, previousSearch, routeMatch]);
};